import React, { useEffect, useState } from "react";
import BaseModalAnimated from "../../../components/modal/BaseModalAnimated";
import CustomInput from "../../../components/form/CustomInput";
import CustomSelect from "../../../components/form/CustomSelect";
import CustomButton from "../../../components/form/CustomButton";
import { useFormik } from "formik";
import * as Yup from "yup";
import { servicesOrderResource, supplier_idsResource, suppliersResource, trailerTrucksResource } from "../../../helpers/configRoutes/backend_helper";
import { showFormErrors } from "../../../helpers/showFormErrors";
import FileUploader from "../../Loads/FileUpdater";
import PreviewPDF from "../../../components/modal/PreviewPdf"
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const AddUpServiceOrder = ({ modal, setModal, data, setData }) => {
    const { validations, service } = useSelector(state => state.ServiceOrders)
    const [modalPrev, setModalPrev] = useState({ show: false, url: '' })
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()
    // Opciones de ejemplo para el CustomSelect de supplier_id
    const [supplierOptions, setSupplierOptions] = useState([
        { name: "Truck LLC", id: 1 },
        { name: "supplier_id 2", id: 2 },
        { name: "supplier_id 3", id: 3 },
    ]);

    const [trucks, setTrucks] = useState([]);
    const [trailers, setTrailers] = useState([]);
    useEffect(() => {
        const getCatalogs = async () => {
            try {
                const response = await suppliersResource('get', { params: { select: true } })
                setSupplierOptions(response.suppliers)
                const responseTrucks = await trailerTrucksResource("get", { params: { select: true, truck: true } });
                setTrucks(responseTrucks.items);
                const responseTrailers = await trailerTrucksResource("get", { params: { select: true, truck: '' } });
                setTrailers(responseTrailers.items);

            } catch (error) {
                console.error("Error obtaining trailer trucks:", error);
            }
        };

        getCatalogs();
    }, []);

    // Inicializamos Formik
    const validation = useFormik({
        initialValues: service,
        validationSchema: Yup.object().shape({
            ...validations
        }).test({
            name: "at-least-one",
            message: "Debes proporcionar al menos un truck_id o trailer_id",
            test: function (values) {
                return values.truck_id || values.trailer_id;
            }
        }),
        onSubmit: async (values, { setErrors }) => {
            console.log(values)
            let newArray = data.map((d) => {
                if (d.id == values.id) {
                    values.status = true
                    return values
                }
                return d
            })
            setData(newArray)
            setModal({show:false})
        }
    });


    const deleteItem = (list, item) => {
        if (list == 'evidences') {
            const array = validation.values.evidences
            const evidencesDeleted = validation.values.evidences_deleted || [];
            let newArray = array.filter((f) => {
                if (f.id != item.id) {
                    return f
                }
            })
            evidencesDeleted.push(item.id);
            validation.setFieldValue('evidences_deleted', evidencesDeleted);
            validation.setFieldValue('evidences', newArray);
        }
        if (list == 'stops') {
            const array = validation.values.stops
            const stopsDeleted = validation.values.stops_deleted || [];
            let newArray = array.filter((f) => {
                if (f.order != item.order) {
                    return f
                }
            })
            stopsDeleted.push(item.id);
            validation.setFieldValue('stops_deleted', stopsDeleted);
            validation.setFieldValue('stops', newArray);
        }
    }


    useEffect(() => {
        const getMilesTrailer = async () => {
            if (validation.values.trailer_id) {
                const responseTrailerMiles = await trailerTrucksResource('show', {}, validation.values.trailer_id);
                validation.setFieldValue('current_mileage_trailer', responseTrailerMiles.items?.current_mileage)
            }
        };
        getMilesTrailer();
    }, [validation.values.trailer_id]);

    useEffect(() => {
        const getMilesTruck = async () => {
            if (validation.values.truck_id) {
                const responseTruckMiles = await trailerTrucksResource('show', {}, validation.values.truck_id);
                validation.setFieldValue('current_mileage_truck', responseTruckMiles.items?.current_mileage)
            }
        };
        getMilesTruck();
    }, [validation.values.truck_id]);

    return (
        <BaseModalAnimated modal={modal} setModal={setModal}>
            {/* Contenedor principal del modal */}
            <div className="bg-mts-white rounded-lg max-w-2xl w-full mx-auto p-6 shadow-md">
                <form
                    onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        showFormErrors(validation);
                        return false;
                    }}
                >
                    {/* Contenedor de campos en dos columnas */}
                    <div className="grid grid-cols-2 gap-4 mb-4">
                        {/* Internal ID */}
                        <CustomInput
                            label="Internal ID"
                            type="text"
                            name="internalId"
                            placeholder="S898"
                            labelClassName="font-medium"
                            error={validation?.errors?.internalId}
                            value={validation?.values?.internalId}
                            handleChange={validation.handleChange}
                        />

                        {/* supplier_id (Select + Link) */}
                        <div>
                            <div className="flex items-center gap-3 flex-nowrap">
                                <CustomSelect
                                    name="supplier_id"
                                    label={'Supplier'}
                                    options={supplierOptions}
                                    error={validation?.errors?.supplier_id}
                                    value={validation?.values?.supplier_id}
                                    handleChange={validation.handleChange}
                                    placeholder="Select supplier..."
                                    className="bg-gray-50 border border-gray-200 text-gray-700 rounded-md px-3 py-2 focus:outline-none focus:border-blue-400 flex-1"
                                />
                                <button
                                    onClick={() => navigate('/suppliers')}
                                    className="text-mts-blue-primary text-sm hover:underline whitespace-nowrap"
                                >
                                    + Add New supplier_id
                                </button>
                            </div>
                        </div>

                        {/* Service Description */}
                        <CustomInput
                            label="Service Description"
                            type="text"
                            name="description"
                            placeholder="Change of tires"
                            labelClassName="font-medium"
                            error={validation?.errors?.description}
                            value={validation?.values?.description}
                            handleChange={validation.handleChange}
                        />

                        {/* Estimated Cost */}
                        <CustomInput
                            label="Estimated Cost"
                            type="text"
                            name="estimated_cost"
                            placeholder="$2,000 USD"
                            labelClassName="font-medium"
                            error={validation?.errors?.estimated_cost}
                            value={validation?.values?.estimated_cost}
                            handleChange={validation.handleChange}
                        />

                        {/* Creation Date */}
                        <CustomInput
                            label="Creation Date"
                            type="date"
                            name="creation_date"
                            labelClassName="font-medium"
                            error={validation?.errors?.creation_date}
                            value={validation?.values?.creation_date}
                            handleChange={validation.handleChange}
                        />

                        {/* Due Date */}
                        <CustomInput
                            label="Due Date"
                            type="date"
                            name="due_date"
                            labelClassName="font-medium"
                            error={validation?.errors?.due_date}
                            value={validation?.values?.due_date}
                            handleChange={validation.handleChange}
                        />

                        {/* Truck Unit Number */}
                        <CustomSelect
                            name="truck_id"
                            label={'Truck'}
                            options={trucks}                   // Array de opciones
                            error={validation?.errors?.truck_id}        // Manejo de error vía Formik
                            value={validation?.values?.truck_id}        // Valor controlado por Formik
                            handleChange={validation.handleChange}       // Formik controla el onChange
                            placeholder="Select Truck Unit..."
                            className="bg-gray-50 border border-gray-200 text-gray-700 rounded-md px-3 py-2 focus:outline-non focus:border-blue-400 flex-1"
                        />

                        {/* Trailer Unit Number */}
                        <CustomSelect
                            label={'Trailer'}
                            name="trailer_id"
                            options={trailers}
                            error={validation?.errors?.trailer_id}        // Manejo de error vía Formik
                            value={validation?.values?.trailer_id}        // Valor controlado por Formik
                            handleChange={validation.handleChange}
                            placeholder="DF681DS"
                            className="bg-gray-50 border border-gray-200 text-gray-700 rounded-md px-3 py-2 focus:outline-non focus:border-blue-400 flex-1"

                        />
                    </div>
                    <div className="mb-4">
                        <label className="font-medium text-gray-700">Enable Mileage Control</label>
                        <div className="flex gap-4 mt-2">
                            <label className="flex items-center gap-2">
                                <input
                                    type="radio"
                                    name="mileage_control"
                                    value="true"
                                    checked={validation.values.mileage_control == 0}
                                    onChange={() => validation.setFieldValue("mileage_control", 0)}
                                    className="form-radio text-blue-500"
                                />
                                No
                            </label>
                            <label className="flex items-center gap-2">
                                <input
                                    type="radio"
                                    name="mileage_control"
                                    value="false"
                                    checked={validation.values.mileage_control == 1}
                                    onChange={() => validation.setFieldValue("mileage_control", 1)}
                                    className="form-radio text-blue-500"
                                />
                                Yes
                            </label>
                        </div>
                    </div>
                    {validation.values.mileage_control ?
                        <div className="grid grid-cols-2 gap-4 mb-4">
                            {validation.values.truck_id &&
                                <>
                                    <CustomInput
                                        label="Current Mileage (Truck)"
                                        type="text"
                                        name="current_mileage_truck"
                                        labelClassName="font-medium"
                                        error={validation?.errors?.current_mileage_truck}
                                        value={validation?.values?.current_mileage_truck}
                                        handleChange={validation.handleChange}
                                    />

                                    <CustomInput
                                        label="Service Interval (Truck) - Every X Miles"
                                        type="text"
                                        name="miles_interval_truck"
                                        labelClassName="font-medium"
                                        error={validation?.errors?.miles_interval_truck}
                                        value={validation?.values?.miles_interval_truck}
                                        handleChange={validation.handleChange}
                                    />
                                </>
                            }
                            {validation.values.trailer_id &&
                                <>
                                    <CustomInput
                                        label="Current Mileage (Trailer)"
                                        type="text"
                                        name="current_mileage_trailer"
                                        labelClassName="font-medium"
                                        error={validation?.errors?.current_mileage_trailer}
                                        value={validation?.values?.current_mileage_trailer}
                                        handleChange={validation.handleChange}
                                    />

                                    <CustomInput
                                        label="Service Interval (Trailer) - Every X Miles"
                                        type="text"
                                        name="miles_interval_trailer"
                                        labelClassName="font-medium"
                                        error={validation?.errors?.miles_interval_trailer}
                                        value={validation?.values?.miles_interval_trailer}
                                        handleChange={validation.handleChange}
                                    />
                                </>
                            }
                        </div>
                        :
                        <></>
                    }
                    <FileUploader validation={validation} setModalPrev={setModalPrev} deleteItem={deleteItem} />
                    {/* Botón centrado al final */}
                    <div className="flex justify-center mt-6">
                        <CustomButton
                            loading={loading}
                            textLoad={'Saving Data...'}
                            type="submit"
                            className="bg-mts-blue-primary hover:bg-mts-blue-hover text-white px-4 py-2 rounded-md"
                        >
                            Add Service Order
                        </CustomButton>
                    </div>
                </form>
                <PreviewPDF modal={modalPrev} setModal={setModalPrev} />
            </div>
        </BaseModalAnimated>
    );
};

export default AddUpServiceOrder;
